import React from 'react';
import PropTypes from 'prop-types';

const ToastSuccess = ({ color = '#86AD20' }) => (
    <svg
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs />
        <g id="Permisos" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-49.000000, -49.000000)" fill={color} fillRule="nonzero">
                <g transform="translate(30.000000, 30.000000)">
                    <g id="Tick" transform="translate(19.000000, 19.000000)">
                        <path
                            d="M10,19.5 C4.75329488,19.5 0.5,15.2467051 0.5,10 C0.5,4.75329488 4.75329488,0.5 10,0.5 C15.2467051,0.5 19.5,4.75329488 19.5,10 C19.5,15.2467051 15.2467051,19.5 10,19.5 Z M10,18.5 C14.6944204,18.5 18.5,14.6944204 18.5,10 C18.5,5.30557963 14.6944204,1.5 10,1.5 C5.30557963,1.5 1.5,5.30557963 1.5,10 C1.5,14.6944204 5.30557963,18.5 10,18.5 Z"
                            id="Combined-Shape"
                        />
                        <path
                            d="M14.1608239,6.73263007 C14.3637158,6.54530826 14.6800466,6.55793037 14.8673684,6.76082234 C15.0546902,6.96371431 15.0420681,7.28004507 14.8391761,7.46736688 L8.340457,13.4673669 C8.14206644,13.6505327 7.83408811,13.6430962 7.64476916,13.4505686 L5.1434883,10.9068951 C4.94987377,10.7099991 4.95253391,10.3934278 5.14942989,10.1998133 C5.34632586,10.0061988 5.66289717,10.0088589 5.8565117,10.2057549 L8.01808748,12.4039658 L14.1608239,6.73263007 Z"
                            id="Path-2"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

ToastSuccess.propTypes = {
    color: PropTypes.string,
};

export default ToastSuccess;
